/**
 * Address Modal Logic for Packstation and Postadresse
 * Handles toggling modals, switching address modes, and validation.
 */

function toggleAddNewAddressModal(addressType, addressId = null) {
  let modalId;
  if (addressId) {
    modalId = 'editAddressModal_' + addressId;
  } else {
    modalId = addressType === 'shipping' ? 'addNewAddressModalShipping' : 'addNewAddressModalBilling';
    // Fallback for generic add modal
    if (!document.getElementById(modalId)) {
        modalId = 'addNewAddressModal';
    }
  }
  
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.toggle('hidden');
  } else {
      console.error('Modal not found:', modalId);
  }
}

function toggleAddressMode(mode, fieldSuffix) {
  const postalFields = document.getElementById('postal-address-fields' + fieldSuffix);
  const packstationFields = document.getElementById('packstation-address-fields' + fieldSuffix);
  const address1Field = document.getElementById('AddressAddress1New' + fieldSuffix);
  const address2Field = document.getElementById('AddressAddress2New' + fieldSuffix);
  const packstationNumberField = document.getElementById('PackstationNumberNew' + fieldSuffix);
  const postnummerField = document.getElementById('PostnummerNew' + fieldSuffix);
  const postalCard = document.getElementById('postal-card' + fieldSuffix);
  const packstationCard = document.getElementById('packstation-card' + fieldSuffix);
  const postalIcon = document.getElementById('postal-icon' + fieldSuffix);
  const packstationIcon = document.getElementById('packstation-icon' + fieldSuffix);
  const postalText = document.getElementById('postal-text' + fieldSuffix);
  const packstationText = document.getElementById('packstation-text' + fieldSuffix);

  if (mode === 'packstation') {
    if (postalFields) postalFields.classList.add('hidden');
    if (packstationFields) packstationFields.classList.remove('hidden');
    
    // Clear and disable postal fields requirements
    if (address1Field) {
      address1Field.removeAttribute('required');
      // address1Field.value = ''; // Don't clear immediately in case of switch back?
    }
    if (address2Field) {
      address2Field.removeAttribute('required');
      // address2Field.value = '';
    }
    
    // Set Packstation fields requirements
    if (packstationNumberField) packstationNumberField.setAttribute('required', 'required');
    if (postnummerField) postnummerField.setAttribute('required', 'required');
    
    // Update UI Cards
    if (postalCard) {
      postalCard.classList.remove('border-green-30', 'bg-green-50', 'shadow-sm');
      postalCard.classList.add('border-gray-200', 'hover:border-gray-300');
    }
    if (packstationCard) {
      packstationCard.classList.add('border-green-30', 'bg-green-50', 'shadow-sm');
      packstationCard.classList.remove('border-gray-200', 'hover:border-gray-300');
    }
    if (postalIcon) postalIcon.classList.replace('text-green-30', 'text-gray-400');
    if (packstationIcon) packstationIcon.classList.replace('text-gray-400', 'text-green-30');
    if (postalText) postalText.classList.replace('text-green-30', 'text-gray-40');
    if (packstationText) packstationText.classList.replace('text-green-30', 'text-gray-40', 'text-green-30');

  } else {
    if (postalFields) postalFields.classList.remove('hidden');
    if (packstationFields) packstationFields.classList.add('hidden');
    
    // Set Postal fields requirements
    if (address1Field) address1Field.setAttribute('required', 'required');
    
    // Clear Packstation fields requirements
    if (packstationNumberField) {
      packstationNumberField.removeAttribute('required');
      // packstationNumberField.value = '';
    }
    if (postnummerField) {
      postnummerField.removeAttribute('required');
      // postnummerField.value = '';
    }

    // Update UI Cards
    if (postalCard) {
      postalCard.classList.add('border-green-30', 'bg-green-50', 'shadow-sm');
      postalCard.classList.remove('border-gray-200', 'hover:border-gray-300');
    }
    if (packstationCard) {
      packstationCard.classList.remove('border-green-30', 'bg-green-50', 'shadow-sm');
      packstationCard.classList.add('border-gray-200', 'hover:border-gray-300');
    }
    if (postalIcon) postalIcon.classList.replace('text-gray-400', 'text-green-30');
    if (packstationIcon) packstationIcon.classList.replace('text-green-30', 'text-gray-400');
    if (postalText) postalText.classList.replace('text-gray-40', 'text-green-30');
    if (packstationText) packstationText.classList.replace('text-green-30', 'text-gray-40');
  }
}

function changeFirstName(fieldSuffix) {
  fieldSuffix = fieldSuffix || '';
  let title = document.getElementById('CustomerTitle' + fieldSuffix);
  let first_name = document.getElementById('AddressFirstNameNew' + fieldSuffix);
  let firstName;
  
  if (title && first_name) {
    if (title.value !== '0' && title.value !== '3') {
      firstName = title.options[title.selectedIndex].text + ' ' + first_name.value;
    } else {
      firstName = first_name.value;
    }
    const firstNameHidden = document.getElementById('first_name' + fieldSuffix);
    if (firstNameHidden) {
      firstNameHidden.value = firstName;
    }
    
    if (title) {
      if (title.value === '0') {
        title.classList.add('text-gray-400');
        title.classList.remove('text-gray-40');
      } else {
        title.classList.remove('text-gray-400');
        title.classList.add('text-gray-40');
      }
    }
  }
}

function validateAndSubmitForm(event, fieldSuffix, addressType) {
  event.preventDefault();
  fieldSuffix = fieldSuffix || '';
  const form = event.target.closest('form');
  const addressMode = form.querySelector('input[name="address_mode' + fieldSuffix + '"]:checked');
  const isPackstation = addressMode && addressMode.value === 'packstation';
  
  // Note: Billing addresses usually shouldn't be Packstations, but if the modal allows it, we validate.
  // The original code had a check: if (isPackstation && addressType === 'billing') alert(...)
  // We'll keep that if addressType is explicitly passed as billing.
  if (isPackstation && addressType === 'billing') {
    alert('Packstation-Adressen können nicht als Rechnungsadresse verwendet werden. Bitte wählen Sie "Postadresse" aus.');
    return;
  }
  
  let isValid = true;

  if (isPackstation) {
    const packstationNumber = document.getElementById('PackstationNumberNew' + fieldSuffix);
    const postnummer = document.getElementById('PostnummerNew' + fieldSuffix);
    const address1Field = document.getElementById('AddressAddress1New' + fieldSuffix);
    const address2Field = document.getElementById('AddressAddress2New' + fieldSuffix);

    if (packstationNumber && (!packstationNumber.value || packstationNumber.value.length !== 3 || !/^\d{3}$/.test(packstationNumber.value))) {
      isValid = false;
      packstationNumber.classList.add('border-red-500');
      const errorSpan = document.getElementById('PackstationNumberError' + fieldSuffix);
      if (errorSpan) errorSpan.classList.remove('hidden');
    } else if (packstationNumber) {
      packstationNumber.classList.remove('border-red-500');
      const errorSpan = document.getElementById('PackstationNumberError' + fieldSuffix);
      if (errorSpan) errorSpan.classList.add('hidden');
    }

    if (postnummer && (!postnummer.value || !/^\d{9,10}$/.test(postnummer.value))) {
      isValid = false;
      postnummer.classList.add('border-red-500');
      const errorSpan = document.getElementById('PostnummerError' + fieldSuffix);
      if (errorSpan) errorSpan.classList.remove('hidden');
    } else if (postnummer) {
      postnummer.classList.remove('border-red-500');
      const errorSpan = document.getElementById('PostnummerError' + fieldSuffix);
      if (errorSpan) errorSpan.classList.add('hidden');
    }

    if (isValid && address1Field && address2Field) {
      const packstationNumberValue = packstationNumber ? packstationNumber.value : '';
      const postnummerValue = postnummer ? postnummer.value : '';
      address1Field.value = 'Packstation ' + packstationNumberValue;
      address2Field.value = 'Postnummer: ' + postnummerValue;
    }
  }

  const requiredFields = form.querySelectorAll('input[required]');
  requiredFields.forEach(field => {
    // Skip hidden Packstation/Postal fields depending on mode
    if (isPackstation && (field.id.includes('AddressAddress1') || field.id.includes('AddressAddress2'))) return;
    if (!isPackstation && (field.id.includes('Packstation') || field.id.includes('Postnummer'))) return;

    const fieldId = field.id.replace('Address', '').replace('New' + fieldSuffix, '');
    const errorSpan = document.getElementById('Address' + fieldId + 'Error' + fieldSuffix);
    
    if (field.value.trim() === '') {
      isValid = false;
      field.classList.add('border-red-500');
      if (errorSpan) errorSpan.classList.remove('hidden');
    } else {
      field.classList.remove('border-red-500');
      if (errorSpan) errorSpan.classList.add('hidden');
    }
  });

  if (isValid) {
    changeFirstName(fieldSuffix);
    form.submit();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const titleSelects = document.querySelectorAll('select[id^="CustomerTitle"]');
  titleSelects.forEach(select => {
    select.addEventListener('change', function() {
      if (this.value === '0') {
        this.classList.add('text-gray-400');
        this.classList.remove('text-gray-40');
      } else {
        this.classList.remove('text-gray-400');
        this.classList.add('text-gray-40');
      }
    });
    
    if (select.value === '0') {
      select.classList.add('text-gray-400');
    } else {
      select.classList.add('text-gray-40');
    }
  });

  // Check for success flag in URL
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('address_saved') === 'true') {
    // Create and show success toast
    const toast = document.createElement('div');
    toast.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 9999; background: white; border-left: 4px solid #10B981; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); padding: 16px 24px; border-radius: 6px; display: flex; align-items: center; gap: 12px; transform: translateX(120%); transition: transform 0.3s ease-out; min-width: 300px;';
    toast.innerHTML = `
      <div class="flex-shrink-0">
        <i class="fas fa-check-circle text-green-500 text-xl"></i>
      </div>
      <div class="ml-3">
        <p class="text-sm font-medium text-gray-900">
          Erfolgreich gespeichert
        </p>
        <p class="text-sm text-gray-500 mt-1">
          Ihre Adresse wurde erfolgreich aktualisiert.
        </p>
      </div>
      <button onclick="this.parentElement.style.transform = 'translateX(120%)'; setTimeout(() => this.parentElement.remove(), 300);" class="ml-auto flex-shrink-0 text-gray-400 hover:text-gray-500 focus:outline-none">
        <i class="fas fa-times"></i>
      </button>
    `;
    document.body.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => {
      toast.style.transform = 'translateX(0)';
    });

    // Auto dismiss
    setTimeout(() => {
      if (document.body.contains(toast)) {
        toast.style.transform = 'translateX(120%)';
        setTimeout(() => {
          if (document.body.contains(toast)) {
            toast.remove();
          }
          // Clean up URL
          window.history.replaceState({}, document.title, window.location.pathname);
        }, 300);
      }
    }, 4000);
  }
});
